import {
  BranchesOutlined,
  DeploymentUnitOutlined,
  SoundOutlined,
  TeamOutlined,
  ToolOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { CoffeeOutlined } from '@ant-design/icons'
import { BulbOutlined } from '@ant-design/icons'
import { Avatar } from 'antd'
import { AvatarProps } from 'antd/lib/avatar/avatar'
import React from 'react'

import { User } from '@/generated/graphql'

interface GroupAvatarProps {
  groupCatId?: number | null
  isOfficial?: boolean
  style?: any
  disableColor?: boolean
}

export const GroupAvatar: React.FC<GroupAvatarProps> = ({
  groupCatId,
  isOfficial,
  style,
  disableColor = false,
  ...props
}) => {
  return (
    {
      0: <TeamOutlined {...props} style={{ ...style, color: !disableColor && '#48bbb5' }} />,
      1: <BranchesOutlined {...props} style={{ ...style, color: !disableColor && '#FFBB45' }} />,
      2: <DeploymentUnitOutlined {...props} style={{ ...style, color: !disableColor && '#B80019' }} />,
      3: <ToolOutlined {...props} style={{ ...style, color: !disableColor && '#125491' }} />,
      4: <CoffeeOutlined {...props} style={{ ...style, color: !disableColor && '#4AA050' }} />,
      5: <BulbOutlined {...props} style={{ ...style, color: !disableColor && '#D0B17A' }} />,
      6: <SoundOutlined {...props} style={{ ...style, color: !disableColor && 'rgb(8, 156, 253)' }} />,
    }[isOfficial ? 6 : groupCatId || 0] || null
  )
}

export const UserAvatar: React.FC<{ user: Pick<User, 'avatarUrl'> | null | undefined } & AvatarProps> = ({
  user,
  ...props
}) => {
  return <Avatar {...props} src={user && user.avatarUrl} icon={user ? undefined : <UserOutlined />} />
}
